import {
  FETCH_TOEGANGSCONTROLES,
  FETCH_TOEGANGSCONTROLE,
  SAVE_TOEGANGSCONTROLE,
  TOGGLE_TOEGANGSCONTROLE,
  TEST_TOEGANGSCONTROLE,
  START_AUTHORIZATION,
  REFRESH_TOKEN,
  TOEGANGSCONTROLE_ERROR
} from "./types";

const API_URL = "/api/admin/toegangscontrole";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

// Haal alle toegangscontrole configuraties op
export const fetchToegangscontroles = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_TOEGANGSCONTROLES,
      payload: data.results
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij ophalen toegangscontrole configuraties"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Haal specifieke toegangscontrole configuratie op
export const fetchToegangscontrole = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_TOEGANGSCONTROLE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij ophalen toegangscontrole configuratie"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Opslaan toegangscontrole configuratie
export const saveToegangscontrole = (configData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(configData)
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: SAVE_TOEGANGSCONTROLE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij opslaan toegangscontrole configuratie"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Schakel toegangscontrole in/uit
export const toggleToegangscontrole = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/toggle`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TOGGLE_TOEGANGSCONTROLE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij schakelen toegangscontrole"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Start OAuth Authorization Flow
export const startAuthorizationFlow = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/authorize`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: START_AUTHORIZATION,
      payload: data
    });
    
    // Open authorization URL in new window
    if (data.authorization_url) {
      window.open(data.authorization_url, '_blank', 'width=600,height=700');
    }
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij starten authorization flow"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Test toegangscontrole configuratie
export const testToegangscontrole = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/test`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TEST_TOEGANGSCONTROLE,
      payload: data.test_result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij testen toegangscontrole"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};

// Refresh access token
export const refreshToken = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/refresh-token`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: REFRESH_TOKEN,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: TOEGANGSCONTROLE_ERROR,
      payload: error.message || "Fout bij vernieuwen token"
    });
    
    return { type: "TOEGANGSCONTROLE_ERROR", error: error.message };
  }
};